import { Icon, IconType, Link, modifiers, Size } from '@outdoria/ui';

import s from './SelectEntityButton.module.scss';

type SelectEntityButtonProps = {
  description: string;
  icon: IconType;
  link: string;
  title: string;
  isDisabled?: boolean;
};
export const SelectEntityButton = ({
  description,
  icon,
  link,
  title,
  isDisabled = false,
}: SelectEntityButtonProps) => {
  return (
    <Link
      className={modifiers(s, 'selectEntityButton', { isDisabled })}
      to={link}>
      <div className={s.selectEntityButton__cover}>
        <Icon icon={icon} size={Size.LARGE} />
      </div>

      <div className={s.selectEntityButton__bottom}>
        <h2 className={s.selectEntityButton__title}>{title}</h2>
        <div className={s.selectEntityButton__description}>{description}</div>
      </div>
    </Link>
  );
};
